(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;
                    if (!f && c) return c(i, !0);
                    if (u) return u(i, !0);
                    var a = new Error("Cannot find module '" + i + "'");
                    throw a.code = "MODULE_NOT_FOUND", a
                }
                var p = n[i] = {exports: {}};
                e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];
                    return o(n || r)
                }, p, p.exports, r, e, n, t)
            }
            return n[i].exports
        }

        for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
        return o
    }

    return r
})()({
    1: [function (require, module, exports) {
        'use strict';
        Object.defineProperty(exports, "__esModule", {value: true});
        exports.acceptWindow = void 0;
        var Layer_1 = require("./Layer");
        var PreferencesWindow_1 = require("./PreferencesWindow");
        var AcceptWindow = function () {
            var options = {
                saveCallback: null,
                ignoreCallback: null,
                declineCallback: null,
                initialCookieSettings: null,
            };
            var render = function () {
                var _a, _b, _c, _d, _e;
                Layer_1.layer.render(false);
                var modal = document.getElementById('webit-cookie-modal');
                var modalBody = document.createElement('div');
                modalBody.classList.add('modal-body');
                var title = document.createElement('h3');
                title.innerHTML = ((_a = options.initialCookieSettings) === null || _a === void 0 ? void 0 : _a.title) || '';
                var description = document.createElement('p');
                description.innerHTML = ((_b = options.initialCookieSettings) === null || _b === void 0 ? void 0 : _b.text) || '';
                var buttonWrapper = document.createElement('div');
                buttonWrapper.classList.add('buttons');
                var buttonAcceptAll = document.createElement('button');
                buttonAcceptAll.innerText = ((_c = options.initialCookieSettings) === null || _c === void 0 ? void 0 : _c.buttons.acceptAll) || '';
                buttonAcceptAll.classList.add('button', 'button-primary');
                buttonAcceptAll.id = 'cookie-button-accept-all';
                buttonAcceptAll.onclick = clickAcceptAll;
                var buttonPreferences = document.createElement('button');
                buttonPreferences.innerText = ((_d = options.initialCookieSettings) === null || _d === void 0 ? void 0 : _d.buttons.openPreferences) || '';
                buttonPreferences.classList.add('button', 'button-secondary');
                buttonPreferences.id = 'cookie-button-preferences';
                buttonPreferences.onclick = function () {
                    return clickPreferences();
                };
                var buttonDecline = document.createElement('button');
                buttonDecline.innerText = ((_e = options.initialCookieSettings) === null || _e === void 0 ? void 0 : _e.buttons.declineAll) || '';
                buttonDecline.classList.add('button', 'button-secondary');
                buttonDecline.id = 'cookie-button-preferences';
                buttonDecline.onclick = options.declineCallback;
                var buttonClose = document.createElement('span');
                buttonClose.classList.add('cookie-close-button');
                buttonClose.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2L2 14" stroke="#212529" stroke-width="3"/><path d="M2 2L14 14" stroke="#212529" stroke-width="3"/></svg>';
                buttonClose.onclick = options.ignoreCallback;
                modal.innerHTML = '';
                modalBody.append(buttonClose);
                modalBody.append(title);
                modalBody.append(description);
                buttonWrapper.append(buttonPreferences);
                buttonWrapper.append(buttonDecline);
                buttonWrapper.append(buttonAcceptAll);
                modalBody.append(buttonWrapper);
                modal.append(modalBody);
            };
            var clickAcceptAll = function () {
                if (options.saveCallback !== null) {
                    options.saveCallback({
                        statistical: true,
                        marketing: true,
                        preferential: true
                    }, 'accept_all', 'new');
                }
            };
            var clickPreferences = function () {
                PreferencesWindow_1.preferencesWindow.render(false);
            };
            return {
                init: function (saveCallback, ignoreCallback, declineCallback, initialCookieSettings) {
                    options.saveCallback = saveCallback;
                    options.ignoreCallback = ignoreCallback;
                    options.declineCallback = declineCallback;
                    options.initialCookieSettings = initialCookieSettings;
                },
                render: function () {
                    render();
                }
            };
        };
        exports.acceptWindow = AcceptWindow();

    }, {"./Layer": 3, "./PreferencesWindow": 4}],
    2: [function (require, module, exports) {
        'use strict';
        Object.defineProperty(exports, "__esModule", {value: true});
        exports.Cookies = void 0;
        var Layer_1 = require("./Layer");
        var AcceptWindow_1 = require("./AcceptWindow");
        var PreferencesWindow_1 = require("./PreferencesWindow");
        var Cookies = function () {
            var edit = false;
            var settings;
            var init = function (initialCookieSettings) {
                settings = initialCookieSettings;
                Layer_1.layer.init(ignoreCookie);
                AcceptWindow_1.acceptWindow.init(setCookie, ignoreCookie, declineCookie, settings);
                PreferencesWindow_1.preferencesWindow.init(setCookie, ignoreCookie, declineCookie, settings);
                PreferencesWindow_1.preferencesWindow.setCookieSettings(loadCookiePreferences());
            };
            var setCookie = function (settings, flow, eventType) {
                var validity = flow === 'accept_all' || (settings.statistical && settings.marketing && settings.preferential) ? 12 : 6;
                createCookie('COOKIES_ACCEPTED', '1', validity);
                createCookie('COOKIES_STATISTICAL', settings.statistical ? '1' : '0', validity);
                createCookie('COOKIES_MARKETING', settings.marketing ? '1' : '0', validity);
                createCookie('COOKIES_PREFERENTIAL', settings.preferential ? '1' : '0', validity);
                PreferencesWindow_1.preferencesWindow.setCookieSettings(loadCookiePreferences());
                Layer_1.layer.hide();
                sendToTrackServer(settings, flow, eventType);
                if (eventType === 'new') {
                    triggerGTM(settings);
                }
            };
            var ignoreCookie = function () {
                Layer_1.layer.hide();
                if (!edit) {
                    sendToTrackServer({
                        statistical: false,
                        marketing: false,
                        preferential: false,
                    }, 'ignore', 'new');
                    createCookie('COOKIES_ACCEPTED', '1', 0.000347);
                    triggerGTM({
                        statistical: false,
                        marketing: false,
                        preferential: false,
                    });
                }
            };
            var declineCookie = function () {
                Layer_1.layer.hide();
                sendToTrackServer({
                    statistical: false,
                    marketing: false,
                    preferential: false,
                }, 'decline', 'new');
                createCookie('COOKIES_ACCEPTED', '1', 6);
                createCookie('COOKIES_STATISTICAL', '0', 6);
                createCookie('COOKIES_MARKETING', '0', 6);
                createCookie('COOKIES_PREFERENTIAL', '0', 6);
                triggerGTM({
                    statistical: false,
                    marketing: false,
                    preferential: false,
                });
            };
            var createCookie = function (name, value, validity) {
                var date = new Date();
                date.setSeconds(date.getSeconds() + 2592000 * validity);
                if (settings.domain === '') {
                    document.cookie = name + '=' + value + '; expires =' + date.toUTCString() + '; path=/';
                } else {
                    document.cookie = name + '=' + value + '; expires =' + date.toUTCString() + '; domain=' + settings.domain + '; path=/';
                }
            };
            var loadCookiePreferences = function () {
                return {
                    statistical: getCookie('COOKIES_STATISTICAL') === '1',
                    marketing: getCookie('COOKIES_MARKETING') === '1',
                    preferential: getCookie('COOKIES_PREFERENTIAL') === '1',
                };
            };
            var isCookiesAccepted = function () {
                return getCookie('COOKIES_ACCEPTED') === '1';
            };
            var getCookie = function (cname) {
                var name = cname + '=';
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return null;
            };
            var sendToTrackServer = function (cookieSettings, flow, eventType) {
                var body = {
                    flow: flow,
                    event_type: eventType,
                    choices: []
                };
                for (var key in cookieSettings) {
                    if (cookieSettings[key] === true) {
                        body.choices.push(key);
                    }
                }
                postData(settings.hitsTrackerURL, body);
            };
            var triggerGTM = function (settings) {
                gtag('consent', 'update', {
                    'ad_personalization': settings.marketing ? 'granted' : 'denied',
                    'ad_storage': settings.marketing ? 'granted' : 'denied',
                    'ad_user_data': settings.marketing ? 'granted' : 'denied',
                    'analytics_storage': settings.statistical ? 'granted' : 'denied',
                    'functionality_storage': settings.preferential ? 'granted' : 'denied',
                    'personalization_storage': settings.preferential ? 'granted' : 'denied',
                    'security_storage': settings.preferential ? 'granted' : 'denied',
                });
                gtag('event', 'accepted_cookie');
            };
            var gtag = function () {
                window.dataLayer.push(arguments);
            };
            var postData = function (url, data) {
                var xhr = new XMLHttpRequest();
                xhr.open('POST', url);
                xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                xhr.onload = function () {
                };
                xhr.onerror = function () {
                };
                xhr.send(JSON.stringify(data));
            };
            return {
                init: function (initialCookieSettings) {
                    init(initialCookieSettings);
                },
                open: function () {
                    if (isCookiesAccepted()) {
                        triggerGTM(loadCookiePreferences());
                    } else {
                        AcceptWindow_1.acceptWindow.render();
                    }
                },
                edit: function () {
                    PreferencesWindow_1.preferencesWindow.render(true);
                }
            };
        };
        exports.Cookies = Cookies;

    }, {"./AcceptWindow": 1, "./Layer": 3, "./PreferencesWindow": 4}],
    3: [function (require, module, exports) {
        'use strict';
        Object.defineProperty(exports, "__esModule", {value: true});
        exports.layer = void 0;
        var Layer = function () {
            var options = {
                ignoreCallback: null,
                edit: false
            };
            var render = function (edit) {
                options.edit = edit;
                var layer = document.getElementById('webit-cookie-layer');
                var modalWrapper;
                if (layer === null) {
                    layer = document.createElement('div');
                    layer.id = 'webit-cookie-layer';
                    var background = document.createElement('div');
                    background.id = 'webit-cookie-background';
                    var modal = document.createElement('div');
                    modal.id = 'webit-cookie-modal';
                    modalWrapper = document.createElement('div');
                    modalWrapper.id = 'webit-cookie-modal-wrapper';
                    modalWrapper.append(modal);
                    layer.append(background);
                    layer.append(modalWrapper);
                    var body = document.getElementsByTagName('body')[0];
                    body.append(layer);
                }
            };
            var changeIgnoreClick = function (ignoreCallback) {
                options.ignoreCallback = ignoreCallback;
                var background = document.getElementById('webit-cookie-background');
                if (background !== null) {
                    background.onclick = ignoreCallback;
                }
            };
            var hide = function () {
                var layer = document.getElementById('webit-cookie-layer');
                if (layer !== null) {
                    layer.replaceWith('');
                }
            };
            return {
                init: function (ignoreCallback) {
                    options.ignoreCallback = ignoreCallback;
                },
                render: function (edit) {
                    render(edit);
                },
                hide: function () {
                    hide();
                },
                changeIgnoreClick: function (ignoreCallback) {
                    changeIgnoreClick(ignoreCallback);
                },
            };
        };
        exports.layer = Layer();

    }, {}],
    4: [function (require, module, exports) {
        'use strict';
        Object.defineProperty(exports, "__esModule", {value: true});
        exports.preferencesWindow = void 0;
        var Layer_1 = require("./Layer");
        var PreferencesWindow = function () {
            var options = {
                saveCallback: null,
                ignoreCallback: null,
                declineCallback: null,
                cookieSettings: {
                    statistical: false,
                    marketing: false,
                    preferential: false,
                },
                edit: false,
                editable: true,
                initialCookieSettings: null,
            };
            var render = function (edit) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                if (!options.editable) {
                    return;
                }
                options.edit = edit;
                Layer_1.layer.render(edit);
                var modal = document.getElementById('webit-cookie-modal');
                modal.innerHTML = '';
                var modalBody = document.createElement('div');
                modalBody.classList.add('modal-body');
                var title = document.createElement('h3');
                title.innerHTML = ((_a = options.initialCookieSettings) === null || _a === void 0 ? void 0 : _a.title) || '';
                var description = document.createElement('p');
                description.innerHTML = ((_b = options.initialCookieSettings) === null || _b === void 0 ? void 0 : _b.text) || '';
                var buttonClose = document.createElement('span');
                buttonClose.classList.add('cookie-close-button');
                buttonClose.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2L2 14" stroke="#212529" stroke-width="3"/><path d="M2 2L14 14" stroke="#212529" stroke-width="3"/></svg>';
                buttonClose.onclick = options.edit ? Layer_1.layer.hide : options.ignoreCallback;
                var cookieWrapper = document.createElement('ul');
                cookieWrapper.classList.add('cookie-wrapper');
                var technicalCookie = document.createElement('li');
                var technicalCookieLabel = document.createElement('label');
                technicalCookieLabel.innerHTML = ((_c = options.initialCookieSettings) === null || _c === void 0 ? void 0 : _c.technical.label) || '';
                var technicalCookieText = document.createElement('div');
                technicalCookieText.innerHTML = ((_d = options.initialCookieSettings) === null || _d === void 0 ? void 0 : _d.technical.text) || '';
                technicalCookieText.id = 'technical-cookie-text';
                technicalCookieText.classList.add('cookie-description', 'hide');
                technicalCookie.append(technicalCookieLabel);
                var technicalCookieCheckbox = document.createElement('input');
                technicalCookieCheckbox.type = 'checkbox';
                technicalCookieCheckbox.name = 'technical';
                technicalCookieCheckbox.checked = true;
                technicalCookieCheckbox.disabled = true;
                technicalCookieCheckbox.role = 'switch';
                technicalCookie.append(technicalCookieCheckbox);
                var technicalCookieArrow = document.createElement('span');
                technicalCookieArrow.classList.add('arrow');
                technicalCookieArrow.onclick = function () {
                    return openDescription(technicalCookieText);
                };
                var technicalCookieSvg = document.createElementNS('http://www.w3.org/2000/svg', "svg");
                technicalCookieSvg.innerHTML = '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 5.76911L2.14631 0L0 2.11527L5.85378 7.88438L5.85352 7.88464L7.99983 9.99991L15.9997 2.11573L13.8534 0.000459256L8.0001 5.76911Z" fill="#696969"/>';
                technicalCookieSvg.setAttribute('width', '16');
                technicalCookieSvg.setAttribute('height', '10');
                technicalCookieSvg.setAttribute('viewBox', '0 0 16 10');
                technicalCookieSvg.setAttribute('fill', 'none');
                technicalCookieArrow.append(technicalCookieSvg);
                technicalCookie.append(technicalCookieArrow);
                technicalCookie.append(technicalCookieText);
                cookieWrapper.append(technicalCookie);
                var statisticalCookie = document.createElement('li');
                var statisticalCookieLabel = document.createElement('label');
                statisticalCookieLabel.innerHTML = ((_e = options.initialCookieSettings) === null || _e === void 0 ? void 0 : _e.statistical.label) || '';
                var statisticalCookieText = document.createElement('div');
                statisticalCookieText.innerHTML = ((_f = options.initialCookieSettings) === null || _f === void 0 ? void 0 : _f.statistical.text) || '';
                statisticalCookieText.id = 'statistical-cookie-text';
                statisticalCookieText.classList.add('cookie-description', 'hide');
                statisticalCookie.append(statisticalCookieLabel);
                var statisticalCookieCheckbox = document.createElement('input');
                statisticalCookieCheckbox.type = 'checkbox';
                statisticalCookieCheckbox.name = 'statistical';
                statisticalCookieCheckbox.role = 'switch';
                statisticalCookieCheckbox.checked = options.cookieSettings.statistical;
                statisticalCookieCheckbox.onchange = function () {
                    return switchValue(statisticalCookieCheckbox);
                };
                statisticalCookie.append(statisticalCookieCheckbox);
                var statisticalCookieArrow = document.createElement('span');
                statisticalCookieArrow.classList.add('arrow');
                statisticalCookieArrow.onclick = function () {
                    return openDescription(statisticalCookieText);
                };
                var statisticalCookieSvg = document.createElementNS('http://www.w3.org/2000/svg', "svg");
                statisticalCookieSvg.innerHTML = '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 5.76911L2.14631 0L0 2.11527L5.85378 7.88438L5.85352 7.88464L7.99983 9.99991L15.9997 2.11573L13.8534 0.000459256L8.0001 5.76911Z" fill="#696969"/>';
                statisticalCookieSvg.setAttribute('width', '16');
                statisticalCookieSvg.setAttribute('height', '10');
                statisticalCookieSvg.setAttribute('viewBox', '0 0 16 10');
                statisticalCookieSvg.setAttribute('fill', 'none');
                statisticalCookieArrow.append(statisticalCookieSvg);
                statisticalCookie.append(statisticalCookieArrow);
                statisticalCookie.append(statisticalCookieText);
                cookieWrapper.append(statisticalCookie);
                var marketingCookie = document.createElement('li');
                var marketingCookieLabel = document.createElement('label');
                marketingCookieLabel.innerHTML = ((_g = options.initialCookieSettings) === null || _g === void 0 ? void 0 : _g.marketing.label) || '';
                var marketingCookieText = document.createElement('div');
                marketingCookieText.innerHTML = ((_h = options.initialCookieSettings) === null || _h === void 0 ? void 0 : _h.marketing.text) || '';
                marketingCookieText.id = 'marketing-cookie-text';
                marketingCookieText.classList.add('cookie-description', 'hide');
                marketingCookie.append(marketingCookieLabel);
                var marketingCookieCheckbox = document.createElement('input');
                marketingCookieCheckbox.type = 'checkbox';
                marketingCookieCheckbox.name = 'marketing';
                marketingCookieCheckbox.role = 'switch';
                marketingCookieCheckbox.checked = options.cookieSettings.marketing;
                marketingCookieCheckbox.onchange = function () {
                    return switchValue(marketingCookieCheckbox);
                };
                marketingCookie.append(marketingCookieCheckbox);
                var marketingCookieArrow = document.createElement('span');
                marketingCookieArrow.classList.add('arrow');
                marketingCookieArrow.onclick = function () {
                    return openDescription(marketingCookieText);
                };
                var marketingCookieSvg = document.createElementNS('http://www.w3.org/2000/svg', "svg");
                marketingCookieSvg.innerHTML = '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 5.76911L2.14631 0L0 2.11527L5.85378 7.88438L5.85352 7.88464L7.99983 9.99991L15.9997 2.11573L13.8534 0.000459256L8.0001 5.76911Z" fill="#696969"/>';
                marketingCookieSvg.setAttribute('width', '16');
                marketingCookieSvg.setAttribute('height', '10');
                marketingCookieSvg.setAttribute('viewBox', '0 0 16 10');
                marketingCookieSvg.setAttribute('fill', 'none');
                marketingCookieArrow.append(marketingCookieSvg);
                marketingCookie.append(marketingCookieArrow);
                marketingCookie.append(marketingCookieText);
                cookieWrapper.append(marketingCookie);
                var preferentialCookie = document.createElement('li');
                var preferentialCookieLabel = document.createElement('label');
                preferentialCookieLabel.innerHTML = ((_j = options.initialCookieSettings) === null || _j === void 0 ? void 0 : _j.preferential.label) || '';
                var preferentialCookieText = document.createElement('div');
                preferentialCookieText.innerHTML = ((_k = options.initialCookieSettings) === null || _k === void 0 ? void 0 : _k.preferential.text) || '';
                preferentialCookieText.id = 'preferential-cookie-text';
                preferentialCookieText.classList.add('cookie-description', 'hide');
                preferentialCookie.append(preferentialCookieLabel);
                var preferentialCookieCheckbox = document.createElement('input');
                preferentialCookieCheckbox.type = 'checkbox';
                preferentialCookieCheckbox.name = 'preferential';
                preferentialCookieCheckbox.role = 'switch';
                preferentialCookieCheckbox.checked = options.cookieSettings.preferential;
                preferentialCookieCheckbox.onchange = function () {
                    return switchValue(preferentialCookieCheckbox);
                };
                preferentialCookie.append(preferentialCookieCheckbox);
                var preferentialCookieArrow = document.createElement('span');
                preferentialCookieArrow.classList.add('arrow');
                preferentialCookieArrow.onclick = function () {
                    return openDescription(preferentialCookieText);
                };
                var preferentialCookieSvg = document.createElementNS('http://www.w3.org/2000/svg', "svg");
                preferentialCookieSvg.innerHTML = '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 5.76911L2.14631 0L0 2.11527L5.85378 7.88438L5.85352 7.88464L7.99983 9.99991L15.9997 2.11573L13.8534 0.000459256L8.0001 5.76911Z" fill="#696969"/>';
                preferentialCookieSvg.setAttribute('width', '16');
                preferentialCookieSvg.setAttribute('height', '10');
                preferentialCookieSvg.setAttribute('viewBox', '0 0 16 10');
                preferentialCookieSvg.setAttribute('fill', 'none');
                preferentialCookieArrow.append(preferentialCookieSvg);
                preferentialCookie.append(preferentialCookieArrow);
                preferentialCookie.append(preferentialCookieText);
                cookieWrapper.append(preferentialCookie);
                var buttonWrapper = document.createElement('div');
                buttonWrapper.classList.add('buttons');
                var buttonAcceptAll = document.createElement('button');
                buttonAcceptAll.innerText = ((_l = options.initialCookieSettings) === null || _l === void 0 ? void 0 : _l.buttons.acceptAll) || '';
                buttonAcceptAll.classList.add('button', 'button-primary');
                buttonAcceptAll.id = 'cookie-button-accept-all';
                buttonAcceptAll.onclick = clickAcceptAll;
                var buttonSelectPreferences = document.createElement('button');
                buttonSelectPreferences.innerText = ((_m = options.initialCookieSettings) === null || _m === void 0 ? void 0 : _m.buttons.acceptPreferences) || '';
                buttonSelectPreferences.classList.add('button', 'button-secondary');
                buttonSelectPreferences.id = 'cookie-button-select-preferences';
                buttonSelectPreferences.onclick = function () {
                    return clickAcceptPreferences();
                };
                var buttonDecline = document.createElement('button');
                buttonDecline.innerText = ((_o = options.initialCookieSettings) === null || _o === void 0 ? void 0 : _o.buttons.declineAll) || '';
                buttonDecline.classList.add('button', 'button-secondary');
                buttonDecline.id = 'cookie-button-preferences';
                buttonDecline.onclick = function () {
                    return clickDecline();
                };
                modalBody.append(buttonClose);
                modalBody.append(title);
                modalBody.append(description);
                modalBody.append(cookieWrapper);
                buttonWrapper.append(buttonSelectPreferences);
                buttonWrapper.append(buttonDecline);
                buttonWrapper.append(buttonAcceptAll);
                modalBody.append(buttonWrapper);
                modal.append(modalBody);
            };
            var clickAcceptPreferences = function () {
                if (options.saveCallback !== null) {
                    options.saveCallback({
                        statistical: options.cookieSettings.statistical,
                        marketing: options.cookieSettings.marketing,
                        preferential: options.cookieSettings.preferential
                    }, 'preferences', options.edit ? 'edit' : 'new');
                }
            };
            var clickAcceptAll = function () {
                options.cookieSettings.statistical = true;
                options.cookieSettings.marketing = true;
                options.cookieSettings.preferential = true;
                if (options.saveCallback !== null) {
                    options.saveCallback({
                        statistical: true,
                        marketing: true,
                        preferential: true
                    }, 'accept_all', 'new');
                }
            };
            var clickDecline = function () {
                options.cookieSettings.statistical = false;
                options.cookieSettings.marketing = false;
                options.cookieSettings.preferential = false;
                if (options.declineCallback !== null) {
                    options.declineCallback();
                }
            };
            var openDescription = function (descriptionElement) {
                if (descriptionElement.classList.contains('hide')) {
                    var descriptionElements = document.getElementsByClassName('cookie-description');
                    for (var i = 0; i < descriptionElements.length; i++) {
                        descriptionElements[i].classList.add('hide');
                    }
                    descriptionElement.classList.remove('hide');
                } else {
                    descriptionElement.classList.add('hide');
                }
            };
            var save = function () {
                if (options.saveCallback !== null) {
                    options.saveCallback(options.cookieSettings, 'preferences', options.edit ? 'update' : 'new');
                }
            };
            var openClose = function (element) {
                if (element.classList.contains('opened')) {
                    element.classList.remove('opened');
                } else {
                    element.classList.add('opened');
                }
            };
            var switchValue = function (checkbox) {
                if (checkbox.checked) {
                    switch (checkbox.name) {
                        case 'statistical':
                            options.cookieSettings.statistical = true;
                            break;
                        case 'marketing':
                            options.cookieSettings.marketing = true;
                            break;
                        case 'preferential':
                            options.cookieSettings.preferential = true;
                    }
                } else {
                    switch (checkbox.name) {
                        case 'statistical':
                            options.cookieSettings.statistical = false;
                            break;
                        case 'marketing':
                            options.cookieSettings.marketing = false;
                            break;
                        case 'preferential':
                            options.cookieSettings.preferential = false;
                    }
                }
            };
            return {
                init: function (saveCallback, ignoreCallback, declineCallback, initialCookieSettings) {
                    options.saveCallback = saveCallback;
                    options.ignoreCallback = ignoreCallback;
                    options.declineCallback = declineCallback;
                    options.initialCookieSettings = initialCookieSettings;
                },
                setCookieSettings: function (cookieSettings) {
                    options.cookieSettings = cookieSettings;
                },
                render: function (edit) {
                    render(edit);
                }
            };
        };
        exports.preferencesWindow = PreferencesWindow();

    }, {"./Layer": 3}],
    5: [function (require, module, exports) {
        'use strict';
        Object.defineProperty(exports, "__esModule", {value: true});
        exports.SettingsMerger = void 0;
        var SettingsMerger = function () {
            var convert = function (arg) {
                return (String(arg)).valueOf();
            };
            var merge = function (defaultInitialCookieSettings, webCookieSettings) {
                return {
                    domain: webCookieSettings.domain !== undefined ? convert(webCookieSettings.domain) : defaultInitialCookieSettings.domain,
                    title: webCookieSettings.title !== undefined ? convert(webCookieSettings.title) : defaultInitialCookieSettings.title,
                    text: webCookieSettings.text !== undefined ? convert(webCookieSettings.text) : defaultInitialCookieSettings.text,
                    technical: {
                        exists: webCookieSettings.technical !== undefined && webCookieSettings.technical.exists !== undefined ? (!!webCookieSettings.technical.exists) : defaultInitialCookieSettings.technical.exists,
                        label: webCookieSettings.technical !== undefined && webCookieSettings.technical.label !== undefined ? convert(webCookieSettings.technical.label) : defaultInitialCookieSettings.technical.label,
                        text: webCookieSettings.technical !== undefined && webCookieSettings.technical.text !== undefined ? convert(webCookieSettings.technical.text) : defaultInitialCookieSettings.technical.text,
                    },
                    statistical: {
                        exists: webCookieSettings.statistical !== undefined && webCookieSettings.statistical.exists !== undefined ? (!!webCookieSettings.statistical.exists) : defaultInitialCookieSettings.statistical.exists,
                        label: webCookieSettings.statistical !== undefined && webCookieSettings.statistical.label !== undefined ? convert(webCookieSettings.statistical.label) : defaultInitialCookieSettings.statistical.label,
                        text: webCookieSettings.statistical !== undefined && webCookieSettings.statistical.text !== undefined ? convert(webCookieSettings.statistical.text) : defaultInitialCookieSettings.statistical.text,
                    },
                    preferential: {
                        exists: webCookieSettings.preferential !== undefined && webCookieSettings.preferential.exists !== undefined ? (!!webCookieSettings.preferential.exists) : defaultInitialCookieSettings.preferential.exists,
                        label: webCookieSettings.preferential !== undefined && webCookieSettings.preferential.label !== undefined ? convert(webCookieSettings.preferential.label) : defaultInitialCookieSettings.preferential.label,
                        text: webCookieSettings.preferential !== undefined && webCookieSettings.preferential.text !== undefined ? convert(webCookieSettings.preferential.text) : defaultInitialCookieSettings.preferential.text,
                    },
                    marketing: {
                        exists: webCookieSettings.marketing !== undefined && webCookieSettings.marketing.exists !== undefined ? (!!webCookieSettings.marketing.exists) : defaultInitialCookieSettings.marketing.exists,
                        label: webCookieSettings.marketing !== undefined && webCookieSettings.marketing.label !== undefined ? convert(webCookieSettings.marketing.label) : defaultInitialCookieSettings.marketing.label,
                        text: webCookieSettings.marketing !== undefined && webCookieSettings.marketing.text !== undefined ? convert(webCookieSettings.marketing.text) : defaultInitialCookieSettings.marketing.text,
                    },
                    buttons: {
                        acceptAll: webCookieSettings.buttons !== undefined && webCookieSettings.buttons.acceptAll !== undefined ? convert(webCookieSettings.buttons.acceptAll) : defaultInitialCookieSettings.buttons.acceptAll,
                        declineAll: webCookieSettings.buttons !== undefined && webCookieSettings.buttons.declineAll !== undefined ? convert(webCookieSettings.buttons.declineAll) : defaultInitialCookieSettings.buttons.declineAll,
                        openPreferences: webCookieSettings.buttons !== undefined && webCookieSettings.buttons.openPreferences !== undefined ? convert(webCookieSettings.buttons.openPreferences) : defaultInitialCookieSettings.buttons.openPreferences,
                        acceptPreferences: webCookieSettings.buttons !== undefined && webCookieSettings.buttons.acceptPreferences !== undefined ? convert(webCookieSettings.buttons.acceptPreferences) : defaultInitialCookieSettings.buttons.acceptPreferences,
                    },
                    hitsTrackerURL: webCookieSettings.hitsTrackerURL !== undefined ? convert(webCookieSettings.hitsTrackerURL) : defaultInitialCookieSettings.hitsTrackerURL,
                };
            };
            return {
                merge: function (defaultInitialCookieSettings, webCookieSettings) {
                    return merge(defaultInitialCookieSettings, webCookieSettings);
                },
            };
        };
        exports.SettingsMerger = SettingsMerger;

    }, {}],
    6: [function (require, module, exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {value: true});
        var Cookies_1 = require("../components/Cookies");
        var DefaultInitialCookieSettings_1 = require("../templates/DefaultInitialCookieSettings");
        var SettingsMerger_1 = require("../components/SettingsMerger");
        var settingsMerger = new SettingsMerger_1.SettingsMerger();
        var cookie = (0, Cookies_1.Cookies)();
        cookie.init(settingsMerger.merge(DefaultInitialCookieSettings_1.DefaultInitialCookieSettings, window.cookieSettings));
        window.cookie = cookie;

    }, {"../components/Cookies": 2, "../components/SettingsMerger": 5, "../templates/DefaultInitialCookieSettings": 7}],
    7: [function (require, module, exports) {
        'use strict';
        Object.defineProperty(exports, "__esModule", {value: true});
        exports.DefaultInitialCookieSettings = void 0;
        var DefaultInitialCookieSettings = {
            domain: '',
            title: 'Preference cookies: pro nejpohodlnější prohlížení webu',
            text: 'Aby naše webové stránky zůstaly tak, jak je znáte, potřebujeme od Vás souhlas se zpracováním souborů cookies tj. malých souborů, které se Vám ukládají v prohlížeči. Slibujeme, že Vaše data u nás budou v bezpečí.',
            technical: {
                exists: true,
                label: '<b>Technické,</b> pro základní funkčnost stránek',
                text: 'Nutné cookies pro správnou funkčnost webu. Data se automaticky mažou po Vašem odchodu.',
            },
            statistical: {
                exists: true,
                label: '<b>Analytické,</b> pro analýzu a optimalizaci webu',
                text: 'Abychom byli schopni pro Vás stránky optimalizovat a zpříjemnit tak Vaši návštěvu. Díky těmto datům víme, co Vás na stránce nejvíce a nejméně zaujalo. Tento sběr je plně anonymní.<br>Více se o uchovávání souborů cookies dozvíte <a target="_blank" href="/stranka/zasady-pouzivani-cookies">zde</a>.',
            },
            preferential: {
                exists: true,
                label: '<b>Preferenční,</b> pro zobrazení stránek na míru',
                text: 'Díky preferenčím cookies Vám dokážeme stránky zobrazit např. ve Vašem jazyce, nebudete tedy muset zbytečně překlikávat.<br>Více se o uchovávání souborů cookies dozvíte <a target="_blank" href="/stranka/zasady-pouzivani-cookies">zde</a>.',
            },
            marketing: {
                exists: true,
                label: '<b>Marketingové,</b> pro zkrocení nerelevantní reklamy',
                text: 'Díky souhlasu s touto částí jsme schopni zobrazovat reklamu na naše produkty. Nebude Vás tedy pronásledovat otravná nerelevantní reklama.<br>Více se o uchovávání souborů cookies dozvíte <a target="_blank" href="/stranka/zasady-pouzivani-cookies">zde</a>.',
            },
            buttons: {
                acceptAll: 'Přijmout vše',
                declineAll: 'Odmítnout vše',
                openPreferences: 'Přizpůsobit',
                acceptPreferences: 'Přijmout vybrané',
            },
            hitsTrackerURL: 'https://cookies-stats.1webit.cz/api/data/collect'
        };
        exports.DefaultInitialCookieSettings = DefaultInitialCookieSettings;

    }, {}]
}, {}, [6])

//# sourceMappingURL=cookie.js.map
